<template>
  <div class="travel_card_layout" :style="{ 'overflow': count < 100 ? 'hidden' : '' }">
    <!-- 活动标题 -->
    <!-- <div v-wechat-title="'魔卡少女樱：回忆钥匙'"></div> -->
    <!-- 首页进入青瓷游戏LOGO -->

    <transition enter-active-class='animated fadeIn' name='fade'>
      <!-- <div @touchmove.prevent class='preloading preloading-sakura' v-show='preloadingShow'></div> -->

      <!-- 显示加载进度 -->
      <div class='preloading-sakura-card' v-if="count < 100">
        <div class="logo"></div>
        <div class="progress-line"></div>
        <div class="progress-text"></div>
        <div class="progress">
          LOADING&nbsp;{{ count }}%
        </div>
      </div>

    </transition>
    <!-- 登录弹窗 -->

    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" @loginSuccess="loginSuccess" :gameName="gameName"
      :downloadUrl="downloadUrl" :loginTypes="loginTypes" :autoOpenOS="false"></Login>
    <Os v-if='isShowOs' v-on:selectCallback='selectCallback' v-on:logoutCallback='osCancell'
      v-on:getSelectInfo='getSelectInfo' :gameName="gameName"></Os>


    <Header :isOnline="1" :config="headerConfig" :isShowInfo="true" :isShowDownLoad="true"
      v-if="horizontalShow == false && verticalShow == false" />

    <div :class="'super_punch_clock_page ' + (isSafari ? 'safari' : '')">
      <div class="content-swiper-container swiper-container" v-show="picSwiperShow">
        <div class="swiper-wrapper" ref="mySwiper">
          <div class="swiper-slide silde-1">
            <div class="frist-contaienr">
              <div class="main">
                <div class="slogan"></div>
                <div class="btn" @click="goToSlide(1)"></div>
              </div>
              <div class="arrow"></div>
            </div>
          </div>
          <div class="swiper-slide silde-2">
            <div class="fourth-contaienr" ref="fourth" id="fourth">
              <div class="top" ref="top_01" id="top_01">
                <div class="title"></div>
                <div class="details" @click="openPopup('ruleShow')"></div>
              </div>
              <div :class="['main', mainBackground ? mainBackground : 'all_main']" ref="fourthChild" id="fourthChild">
                <div class="top_btn">
                  <div v-for="item in btn_list" :class="item.className" @click="btn_Click(item.key)"></div>
                </div>
                <div class="picture-box">
                  <transition-group :enter-active-class="enTerActiveClass" name="list">
                    <div v-for="item in showPoicList" class="picture" @click="picItemClick(item)" :key="item.src">
                      <img :src="item.src" :style="{ 'transform': showPicListTransform[item.card_id - 1] }">
                    </div>
                  </transition-group>
                </div>

                <div v-if="mainBackground === 'notCollected_main' && activity.not_has_card_list.length === 0"
                  class="full">
                </div>

                <div v-if="mainBackground === 'notCollected_main' && activity.not_has_card_list.length === 0">
                </div>
                <div v-else class="page_num">{{ recordIndex }}/{{ totalPages }}</div>
                <div class="btn-box">
                  <!-- <div class="btn btn_picture" @click="pictureListShow = true"></div> -->
                  <div class="btn btn_picture" @click=" openPopup('recordShow')"></div>
                  <div class="btn btn_task" @click="openPopup('taskShow')"></div>
                </div>
                <div class="decoration" ref="decoration" id="decoration"></div>
              </div>
              <div class="arrow_btn arrow_btn-prev " @click="changeRecordIndex('prev')"></div>
              <div class="arrow_btn arrow_btn-next " @click="changeRecordIndex('next')"></div>

              <div class="arrow"></div>
            </div>
          </div>
          <div class="swiper-slide silde-3">
            <div class="second-contaienr">
              <div class="top">
                <div class="title"></div>
                <div class="details" @click="openPopup('ruleShow')"></div>
              </div>
              <div class="main" id="sakura" ref="sakura">
                <div class="sakura" id="sakuraChild" ref="sakuraChild">
                  <div class="cg" @click="openCg(cg_sakura.show)"></div>
                  <img :src="cg_sakura.cg" />
                </div>
                <div class="bottom"></div>
                <div class="roles-swiper-box-background"></div>
                <div class="roles-swiper-box">
                  <div class="roles-swiper-container swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_5.png" />
                        <img class="img_active"
                          src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_5_active.png" alt="">
                      </div>

                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_4.png" />
                        <img class="img_active"
                          src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_4_active.png" alt="">
                      </div>

                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_3.png" />
                        <img class="img_active"
                          src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_3_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_2.png" />
                        <img class="img_active"
                          src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_2_active.png" alt="">
                      </div>
                      <div class="swiper-slide">
                        <img class="img_gray" src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_1.png" />
                        <img class="img_active"
                          src="https://download4.qcplay.com/sakura/cardPrev/02/role_icon_1_active.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="memory" @click="goToSlide(1)"></div>
              <div class="arrow"></div>
            </div>
          </div>

          <div class="swiper-slide silde-4">
            <div class="thrid-contaienr" id="thrid">
              <div class="top">
                <div class="title"></div>
                <div class="details" @click="openPopup('ruleShow')"></div>
              </div>
              <div class="main" id="card" ref="card">
                <div class="swiper-box">
                  <div class="game-swiper-container swiper-no-swiping swiper-container">
                    <div class="swiper-wrapper">
                      <div class="swiper-slide slide1">
                        <div class="info-img-box">
                          <img src="https://download4.qcplay.com/sakura/cardPrev/03/1.png" alt="">
                        </div>
                      </div>
                      <div class="swiper-slide slide2">
                        <div class="info-img-box">
                          <img src="https://download4.qcplay.com/sakura/cardPrev/03/2.png" alt="">
                        </div>
                      </div>
                      <div class="swiper-slide slide3">
                        <div class="info-img-box">
                          <img src="https://download4.qcplay.com/sakura/cardPrev/03/3.png" alt="">
                        </div>
                      </div>
                      <div class="swiper-slide slide4">
                        <div class="info-img-box">
                          <img src="https://download4.qcplay.com/sakura/cardPrev/03/4.png" alt="">
                        </div>
                      </div>
                      <div class="swiper-slide slide5">
                        <div class="info-img-box">
                          <img src="https://download4.qcplay.com/sakura/cardPrev/03/5.png" alt="">
                        </div>
                      </div>
                    </div>
                    <div class="swiper-pagination game-pagination">
                      <div class="swiper-pagination-line"></div>
                    </div>
                  </div>
                  <div class="swiper-button-prev game-button-prev"></div>
                  <div class="swiper-button-next game-button-next"></div>
                </div>

              </div>
              <div class="memory" @click="goToSlide(1)"></div>
            </div>
          </div>



          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>
      <div v-if="horizontalShow" :class="'horizontal_back_btn ' + (isSafari ? 'safari' : '')"
        @click="closePopup('horizontalShow')"></div>
      <div v-if="verticalShow" :class="'vertical_back_btn ' + (isSafari ? 'safari' : '')"
        @click="closePopup('verticalShow')"></div>
      <div :class="'horizontal_arrow ' + (isSafari ? 'safari' : '')" v-if="horizontalShow && cgFlag === false">
        <div class="horizontal_arrow_btn arrow_btn-prev " @click="changeDetails('prev')"></div>
        <div class="horizontal_arrow_btn arrow_btn-next " @click="changeDetails('next')"></div>
      </div>
      <!-- 照片横屏 -->
      <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
        <div :class="'horizontal_page ' + (isSafari ? 'safari' : '')"
          :style="{ 'opacity': horizontalShow ? 1 : 0, 'z-index': horizontalShow ? 21 : 0 }">
          <div class="decoration"></div>
          <div class="picture" id="showImg" ref="showImg">
            <img :src="PickItemDetail1" />
            <img :src="PickItemDetailLoad" style="opacity: 0;z-index:10" v-if="!cgFlag" />
          </div>
          <div class="save_text"></div>

        </div>
      </transition>

      <!-- 照片竖屏 -->
      <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
        <div :class="'vertical_page ' + (isSafari ? 'safari' : '')"
          :style="{ 'opacity': verticalShow ? 1 : 0, 'z-index': verticalShow ? 21 : 0 }">
          <div class="decoration"></div>
          <div class="save_text"></div>
          <div class="picture" id="showImg1" ref="showImg1">
            <img :src="PickItemDetail1">
          </div>

        </div>
      </transition>

      <!-- 照片详情 -->
      <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
        <div class="picture_details_page" v-if="pictureDeatilsShow">
          <div class="back_btn" @click="closePopup('pictureDeatilsShow')"></div>
          <div class="main">
            <div class="picture_bg">
              <div class="picture_border">
                <div class="picture_border_text"></div>
                <div class="pictrue_text" @click="openPopup('horizontalShow')"></div>
                <div class="sakura"></div>


                <div class="picture_border_min">
                  <img class="picture_min" :src="PickItemDetail" @click="openPopup('horizontalShow')" />
                  <div class="lock" v-show="showPicItem.num == 0"></div>
                </div>
              </div>
              <div class="picture_btn_list">
                <div class="btn give" @click="setOperation('give')"></div>
                <div class="btn switch" @click="setOperation('switch')"></div>
                <div class="btn hope" @click="setOperation('hope')"></div>
                <div class="picture_btn_list_text">可供交换数量：{{ showPicItem.num - 1 > 0 ? showPicItem.num - 1 : 0 }}</div>
              </div>
              <div class="decoration" id="decoration1" ref="decoration1"></div>
            </div>
            <div class="sakura_title">
              <img :src="PickItemDetailTitle" />
            </div>
            <div class="arrow_btn arrow_btn-prev " @click="changeDetails('prev')"></div>
            <div class="arrow_btn arrow_btn-next " @click="changeDetails('next')"></div>
          </div>
        </div>
      </transition>

      <!-- 恭喜获取 -->
      <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
        <div class="picture_details_page" v-if="pictureDeatilsShow">
          <div class="decoration"></div>
          <div class="back_btn" @click="pictureDeatilsShow = false"></div>
          <div class="main">
            <div class="picture_bg">
              <div class="picture_border">
                <div class="picture_border_text"></div>
                <div class="pictrue_text" @click=" openPopup('horizontalShow')"></div>
                <div class="sakura"></div>
                <div class="picture_border_min">
                  <img class="picture_min" :src="PickItemDetail" />
                </div>
              </div>
              <div class="picture_btn_list">
                <div class="btn give" @click="setOperation('give')"></div>
                <div class="btn switch" @click="setOperation('switch')"></div>
                <div class="btn hope" @click="setOperation('hope')"></div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <!-- 照片列表 -->
      <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
        <div class="picture_list_page" v-if="pictureListShow">
          <div class="decoration"></div>
          <div class="back_btn" @click="pictureListShow = false"></div>
          <div class="main">
            <div class="picture_bg">
              <div class="picture_text"></div>
              <div class="picture_box">
                <div :class="item.card_id === switchPicItem.card_id ? 'picture_item_active' : 'picture_item'"
                  v-for="item in activity.all_card_list" @click="surePic(item)">
                  <img :src="item.src1">
                  <div v-if="item.card_id === switchPicItem.card_id" class='item_active'></div>
                </div>
                <div class="picture_arrow"></div>
                <div class="picture_btn_list">
                  <div class="btn sure" @click="sureSwitch"></div>
                </div>
              </div>
              <div class="picture_bottom"> </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="switch_wrap popup_wrap" v-show="switchShow" @click="closePopup('switchShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="switchShow">
        <div class="detail_box" v-show="switchShow" :style="getBackgroundStyle">
          <div class="detail">
            <div class="switch_text" v-if="switchPicItem.src">{{ switchToShow ?
    '玩家' + queryObj.gave_account : '' }}使用<span>【{{ showPicItem.name }}】</span>交换<span>【{{
    switchPicItem.name }}】</span>
            </div>
            <div class="switch_text" v-else>请选择一张未收集的照片交换</div>
            <div class="switch_box">
              <div class="switch_pic">
                <img :src="showPicItem.src" />
              </div>
              <div class="switch_pic_icon">
                <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/switch.png" alt=" ">
              </div>
              <div class="switch_pic" @click.stop="switchImg">
                <img v-if="switchPicItem.src1" :src="switchPicItem.src1" />
                <img v-else class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/add.png" alt=" ">
              </div>
            </div>
            <div class="switch_btn">
              <img id="switch_btn" class="img_active" v-if="!switchToShow"
                src="https://download4.qcplay.com/sakura/cardPrev/pop/switch_btn.png" alt=" "
                @click.stop="generateTask()">
              <img id="switch_btn" class="img_active" v-else
                src="https://download4.qcplay.com/sakura/cardPrev/pop/switch_btn.png" alt=" " @click.stop="accept()">
              <div class="switch_text" v-if="!switchToShow">可供交换数量：{{ showPicItem.num - 1 }}</div>
              <div class="switch_text" v-else>可供交换数量：{{ switchPicItem.num - 1 >= 1 ? switchPicItem.num - 1 : '暂无' }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 被操作方弹窗 -->
    <div class="switch_wrap popup_wrap" v-show="operationShow" @click="closePopup('operationShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="operationShow">
        <div class="detail_box" v-show="operationShow" :style="getBackgroundStyle">
          <div class="detail">
            <div class="switch_text">玩家{{ queryObj.gave_account }}向你{{ queryObj.type == 1 ? '赠送了' : '祈愿' }}<span>【{{
    showPicItem.name }}】</span>
              <div>是否确认{{ queryObj.type == 1 ? '领取' : '赠送' }}</div>
            </div>
            <div class="switch_box">
              <div class="switch_pic">
                <img :src="showPicItem.src" />
              </div>
            </div>
            <div class="switch_btn">
              <img class="img_active" v-if="queryObj.type == 1"
                src="https://download4.qcplay.com/sakura/cardPrev/pop/sure.png" alt=" " @click.stop="accept('give')">
              <img class="img_active" v-else src="https://download4.qcplay.com/sakura/cardPrev/pop/give.png" alt=" "
                @click.stop="accept('hope')">
            </div>
          </div>
        </div>
      </transition>
    </div>


    <div class="get_wrap popup_wrap" v-show="getShow" @click="closePopup('getShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="getShow">
        <div class="detail_box" v-show="getShow">
          <div class="detail">
            <div class="picture_bg">
              <div class="picture_border">
                <div class="picture_border_text"></div>
                <div class="pictrue_text" @click.stop="openPopup('horizontalShow')"></div>
                <div class="sakura"></div>
                <div class="picture_border_min">
                  <img class="picture_min" :src="PickItemDetail" />
                </div>
                <div class="picture_border_min_border"></div>
              </div>
            </div>
            <div class="sakura_title">
              <img :src="PickItemDetailTitle" />
            </div>
          </div>
          <div class="close_btn" @click="closePopup('getShow')"></div>
        </div>
      </transition>
    </div>

    <div class="rule_wrap popup_wrap" v-show="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="ruleShow">
        <div class="detail_box" v-show="ruleShow">
          <div class="detail">
            <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/rule_text.png" alt="">
          </div>
          <div class="close_btn" @click="closePopup('ruleShow')"></div>
        </div>
      </transition>
    </div>

    <div class="share_wrap popup_wrap" v-show="shareShow" @click="closePopup('shareShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="shareShow">
        <div class="detail_box" v-show="shareShow">
          <div class="detail">
          </div>
          <img :src="shareImg" style="opacity: 0;z-index:32;position: relative;">
          <div class="bottom_part">
            <div class="share_text" v-if="operation === 'give'">
              好友向你赠送<span>【{{ showPicItem.name }}】</span>
            </div>
            <div class="share_text" v-if="operation === 'hope'">
              好友向你祈愿<span>【{{ showPicItem.name }}】</span>
            </div>
            <div class="share_text" v-if="operation === 'switch'">
              好友正在使用<div><span>【{{ showPicItem.name }}】</span>和你交换<span>【{{ switchPicItem.name }}】</span></div>
            </div>
            <div class="share_box">
              <div class="share_link">
                <div class="link_text">
                  {{ shareLink }}
                </div>
              </div>
              <a class="share_btn" @click="onCopy" id="my-code" href="javascript:;"
                :data-clipboard-text='shareText + optText + shareLink'></a>
            </div>
          </div>
          <div class="save_text"></div>
        </div>
      </transition>
    </div>


    <div class="share_wrap popup_wrap" v-show="shareShow" style="opacity: 0;z-index:8">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="shareShow">
        <div class="detail_box" v-show="shareShow" ref="imageDom" style="transform: scale(1);">
          <div class="detail">
            <div class="qcode_bottom">
              <div class="qrcode-box">
                <div id="qrcode" class="qrcode"></div>
              </div>
              <div class="share_text" v-if="operation === 'give'">
                <div> 好友向你赠送<span>【{{ showPicItem.name }}】</span></div>
                <div>扫描二维码查看详情</div>
              </div>
              <div class="share_text" v-if="operation === 'hope'">
                <div> 好友向你祈愿<span>【{{ showPicItem.name }}】</span></div>
                <div>扫描二维码查看详情</div>
              </div>
              <div class="share_text" v-if="operation === 'switch'">
                好友正在使用<div><span>【{{ showPicItem.name }}】</span>和你交换<span>【{{ switchPicItem.name }}】</span></div>
                <div>扫描二维码查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="record_wrap popup_wrap" v-show="recordShow" @click="closePopup('recordShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="recordShow">
        <div class="detail_box" v-show="recordShow">
          <div class="detail">
            <div class="detail_line"> </div>
            <div class="record_item" v-for="item in activity.record_list">
              <div class="record_item_title">
                <div class="title_text"> {{ item.create_at }}</div>
              </div>
              <div class="record_item_text" v-for="k in item.remark">
                {{ k.type == 4 ? '与' : '' }}
                <span v-if="k.type == 4 || k.type == 3">{{ k.task_name }}</span>
                {{ k.type == 4 ? '' : k.type == 3 ? '' : k.task_name }}
                {{ k.type == 4 ? '交换' : k.type == 3 ? '赠送' : '' }} 获得了
                <span>{{ k.remark }}</span>
              </div>
            </div>

          </div>
          <div class="close_btn" @click="closePopup('recordShow')"></div>
        </div>
      </transition>
    </div>


    <div class="task_wrap popup_wrap" v-show="taskShow" @click="closePopup('taskShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="taskShow">
        <div class="detail_box" v-show="taskShow">
          <div class="detail">
            <div class="detail_title">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_title1.png" alt="">
            </div>
            <div :class="'detail_item ' + (activity.task_info[0].is_get ? 'active' : '')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_01.png" alt="">
              <div class="detail_item_btn">
                <img class="img_active" v-if="!activity.task_info[0]._get"
                  src="https://download4.qcplay.com/sakura/cardPrev/pop/task_01_btn.png" alt=" "
                  @click.stop="doneTask(activity.task_info[0])">
                <img class="img_active" v-else src="https://download4.qcplay.com/sakura/cardPrev/pop/task_02_btn.png"
                  alt="">
              </div>
            </div>
            <div :class="'detail_item ' + (activity.task_info[1].is_get ? 'active' : '')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_02.png" alt="">
              <div class="detail_item_btn">
                <img class="img_active" v-if="!activity.task_info[1]._get"
                  src="https://download4.qcplay.com/sakura/cardPrev/pop/task_01_btn.png" alt=""
                  @click.stop="doneTask(activity.task_info[1])">
                <img class="img_active" v-else src="https://download4.qcplay.com/sakura/cardPrev/pop/task_02_btn.png"
                  alt="">
              </div>
            </div>
            <div class="detail_title" style="margin-top: 10px;">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_title.png" alt="">

            </div>
            <div :class="'detail_item ' + (activity.task_info[2].is_get ? 'active' : '')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_03.png" alt="">
              <div class="detail_item_btn">
                <img class="img_active" v-if="!activity.task_info[2]._get"
                  src="https://download4.qcplay.com/sakura/cardPrev/pop/task_01_btn.png" alt=""
                  @click.stop="doneTask(activity.task_info[2])">
                <img class="img_active" v-else src="https://download4.qcplay.com/sakura/cardPrev/pop/task_02_btn.png"
                  alt="">
              </div>
            </div>
            <div :class="'detail_item ' + (activity.is_bind ? ' active' : '')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_04.png" alt="">
            </div>
            <div :class="'detail_item ' + (activity.reward_list.data[0].is_get ? 'other active' : 'other')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_05.png" alt="">
            </div>

            <div :class="'detail_item ' + (activity.reward_list.data[1].is_get ? 'other active' : 'other')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_06.png" alt="">
            </div>
            <div :class="'detail_item ' + (activity.reward_list.data[2].is_get ? 'other active' : 'other')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_07.png" alt="">
            </div>
            <div :class="'detail_item ' + (activity.reward_list.data[3].is_get ? 'other active' : 'other')">
              <img class="img_active" src="https://download4.qcplay.com/sakura/cardPrev/pop/task_08.png" alt="">
            </div>
          </div>
          <div class="get_btn" v-if="activity.reward_list.number != 0" @click.stop="reward(userInfo)"></div>
          <div class="close_btn" @click="closePopup('taskShow')"></div>
        </div>
      </transition>
    </div>


    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>
  </div>

</template>
<script>
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import Footer from "@/components/Footer";
// import Header from '@/components/Header';
import Header from '../Header/index.vue';
import { headerConfig } from '../headerConfig';
import { onAutoLoginAPI, wechatInfoAPI, onGetInitDataAPI, reward, generateCode, cherryStatus, generateGave, exchange, receive, secretFreeLoginApi } from '../api';
import { analysisParams, getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import Clipboard from "clipboard";
import Swiper from 'swiper'
import "swiper/dist/css/swiper.css"
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'demo',
  components: {
    Footer,
    Header,
    Login,
    Os,
  },

  data() {
    return {
      headerConfig,
      gameName: 'sakura',
      downloadUrl: "https://sakura.qingcijoy.com/official/index.html",
      loginTypes: ["sms", "password"],
      preloadingShow: true,
      titleShow: true,
      preventShow: false,
      logger: null,
      isWechatBrowser: false, // 是否为微信浏览器
      isSafari: false,
      // startImg:require(''),
      count: 0, // 0到100之间
      btn_list: [
        { key: 1, className: 'btn_active', background: 'all_main' },
        { key: 2, className: 'btn', background: 'collected_main' },
        { key: 3, className: 'btn', background: 'notCollected_main' },
      ],
      mainBackground: 'all_main',
      picture_list: [
        {
          imgSrc: 'https://download4.qcplay.com/sakura/cg/1_lock.png',
        },
        {
          imgSrc: 'https://download4.qcplay.com/sakura/cg/1_lock.png',
        },
        {
          imgSrc: 'https://download4.qcplay.com/sakura/cg/1_lock.png',
        },
        {
          imgSrc: 'https://download4.qcplay.com/sakura/cg/1_lock.png',
        },
      ],
      pictureDeatilsShow: false,
      pictureListShow: false,
      horizontalShow: false,
      verticalShow: false,
      shareShow: false,
      switchShow: false,
      switchToShow: false,
      operationShow: false,
      shareLink: '',
      cgPicList: [],
      "activity": {
        "user_id": 4,
        "is_running": true,
        "my_card_list": [
          {
            "num": 3,
            "card_id": 13,
            "name": "\u53ef\u7231\u732b\u54aa"
          },
          {
            "num": 3,
            "card_id": 11,
            "name": "\u751c\u67ff\u8f6f\u66f2\u5947"
          },
          {
            "num": 3,
            "card_id": 1,
            "name": "\u900f\u660e\u4e4b\u7ffc"
          }
        ],
        "task_info": [
          {
            "id": 1,
            "title": "\u6bcf\u65e5\u8fdb\u5165\u6d3b\u52a8\u9875\u9762",
            "is_random": 0,
            "type": 1,
            "link": "",
            "_get": true,
            "is_get": true,
            "number": 3,
            "desc": "\u6bcf\u65e5\u767b\u5165"
          },
          {
            "id": 2,
            "title": "\u6bcf\u65e5\u8d60\u9001\/\u4ea4\u6362\u7167\u7247",
            "is_random": 1,
            "type": 1,
            "link": "",
            "_get": false,
            "is_get": false,
            "number": 1,
            "desc": "\u4ea4\u6362\u4efb\u52a1"
          },
          {
            "id": 3,
            "title": "\u6dfb\u52a0\u4f01\u5fae",
            "is_random": 0,
            "type": 2,
            "link": "weixin:\/\/dl\/business\/?t=ucuRIk6umDn",
            "_get": false,
            "is_get": false,
            "number": 3,
            "desc": "\u4f01\u5fae\u4efb\u52a1"
          }
        ],
        "all_card_list": [
          {
            "card_id": 1,
            "name": "\u900f\u660e\u4e4b\u7ffc"
          },
          {
            "card_id": 2,
            "name": "\u5e93\u6d1b\u9b54\u6cd5\u4f7f"
          },
          {
            "card_id": 3,
            "name": "\u7ea2\u5fc3\u7efd\u653e"
          },
          {
            "card_id": 4,
            "name": "\u661f\u4e4b\u6a31"
          },
          {
            "card_id": 5,
            "name": "\u8776\u4e4b\u68a6"
          },
          {
            "card_id": 6,
            "name": "\u793c\u7269\u5723\u591c"
          },
          {
            "card_id": 7,
            "name": "\u548c\u98ce\u5c0f\u6a31"
          },
          {
            "card_id": 8,
            "name": "\u7ae5\u8bdd\u7ea2\u8336\u4f1a"
          },
          {
            "card_id": 9,
            "name": "\u66fe\u7956\u7236\u7684\u793c\u7269"
          },
          {
            "card_id": 10,
            "name": "\u65b0\u6625\u548c\u670d"
          },
          {
            "card_id": 11,
            "name": "\u751c\u67ff\u8f6f\u66f2\u5947"
          },
          {
            "card_id": 12,
            "name": "\u91d1\u8272\u5947\u8ff9"
          },
          {
            "card_id": 13,
            "name": "\u53ef\u7231\u732b\u54aa"
          },
          {
            "card_id": 14,
            "name": "\u751f\u6d3b\u65e5\u8bb0"
          },
          {
            "card_id": 15,
            "name": "\u955c\u82b1\u957f\u88d9"
          },
          {
            "card_id": 16,
            "name": "\u591c\u660e\u4e4b\u661f"
          },
          {
            "card_id": 17,
            "name": "\u73af\u6e38\u65c5\u884c\u8005"
          },
          {
            "card_id": 18,
            "name": "\u9526\u5c3e\u7409\u91d1"
          },
          {
            "card_id": 19,
            "name": "\u7ef5\u7f8a\u5c0f\u6a31"
          },
          {
            "card_id": 20,
            "name": "\u7fa4\u661f\u793c\u8d5e"
          }
        ],
        "not_has_card_list": [
          {
            "num": 0,
            "card_id": 2,
            "name": "\u5e93\u6d1b\u9b54\u6cd5\u4f7f"
          },
          {
            "num": 0,
            "card_id": 3,
            "name": "\u7ea2\u5fc3\u7efd\u653e"
          },
          {
            "num": 0,
            "card_id": 4,
            "name": "\u661f\u4e4b\u6a31"
          },
          {
            "num": 0,
            "card_id": 5,
            "name": "\u8776\u4e4b\u68a6"
          },
          {
            "num": 0,
            "card_id": 6,
            "name": "\u793c\u7269\u5723\u591c"
          },
          {
            "num": 0,
            "card_id": 7,
            "name": "\u548c\u98ce\u5c0f\u6a31"
          },
          {
            "num": 0,
            "card_id": 8,
            "name": "\u7ae5\u8bdd\u7ea2\u8336\u4f1a"
          },
          {
            "num": 0,
            "card_id": 9,
            "name": "\u66fe\u7956\u7236\u7684\u793c\u7269"
          },
          {
            "num": 0,
            "card_id": 10,
            "name": "\u65b0\u6625\u548c\u670d"
          },
          {
            "num": 0,
            "card_id": 12,
            "name": "\u91d1\u8272\u5947\u8ff9"
          },
          {
            "num": 0,
            "card_id": 14,
            "name": "\u751f\u6d3b\u65e5\u8bb0"
          },
          {
            "num": 0,
            "card_id": 15,
            "name": "\u955c\u82b1\u957f\u88d9"
          },
          {
            "num": 0,
            "card_id": 16,
            "name": "\u591c\u660e\u4e4b\u661f"
          },
          {
            "num": 0,
            "card_id": 17,
            "name": "\u73af\u6e38\u65c5\u884c\u8005"
          },
          {
            "num": 0,
            "card_id": 18,
            "name": "\u9526\u5c3e\u7409\u91d1"
          },
          {
            "num": 0,
            "card_id": 19,
            "name": "\u7ef5\u7f8a\u5c0f\u6a31"
          },
          {
            "num": 0,
            "card_id": 20,
            "name": "\u7fa4\u661f\u793c\u8d5e"
          }
        ],
        "record_list": [
          {
            "create_at": "2024-03-14",
            "remark": [
              {
                "remark": "\u53ef\u7231\u732b\u54aa",
                "type": 1
              }
            ]
          },
          {
            "create_at": "2024-03-15",
            "remark": [
              {
                "remark": "\u751c\u67ff\u8f6f\u66f2\u5947",
                "type": 1
              }
            ]
          },
          {
            "create_at": "2024-03-18",
            "remark": [
              {
                "remark": "\u900f\u660e\u4e4b\u7ffc",
                "type": 1
              }
            ]
          }
        ],
        "reward_list": {
          "data": [
            {
              "number": 3,
              "package_id": 11,
              "_get": true,
              "is_get": false
            },
            {
              "number": 5,
              "package_id": 22,
              "_get": false,
              "is_get": false
            },
            {
              "number": 15,
              "package_id": 33,
              "_get": false,
              "is_get": false
            },
            {
              "number": 20,
              "package_id": 44,
              "_get": false,
              "is_get": false
            }
          ],
          "number": 1
        },
        "is_bind": 0,
        "role_id": "",
        "role_name": "",
        "server_id": 0,
        "server_name": "",
        "platform": ""
      },
      recordType: { 3: '赠送', 4: '交换' },
      recordIndex: 1,
      showPoicList: [
        { "card_id": 1, "name": "透明之翼", "src": "https://download4.qcplay.com/sakura/cg/1_lock.png" }, { "card_id": 2, "name": "库洛魔法使", "src": "https://download4.qcplay.com/sakura/cg/2_lock.png" }, { "card_id": 3, "name": "红心绽放", "src": "https://download4.qcplay.com/sakura/cg/3_lock.png" }, { "card_id": 4, "name": "星之樱", "src": "https://download4.qcplay.com/sakura/cg/4_lock.png" }
      ],
      showPicListTransform: [
        'rotate(0.5deg)', 'rotate(-1deg)', 'rotate(1deg)', 'rotate(-5deg)',
        'rotate( -1deg)', 'rotate(-5deg)', 'rotate(-6deg)', 'rotate( 5deg)',
        'rotate(2deg) translateY(5px) translateX(-2px)', 'rotate(-4deg) translateY(-8px)', 'rotate(-3deg) translateX(2px) translateY(10px)', 'rotate(1deg) translateX(2px)',
        'rotate(-5deg) translateX(-11px) translateY(-5px)', 'rotate(1deg) translateX(-7px)', 'rotate(1deg)', 'rotate(-5deg) translateX(-2px) translateY(5px)',
        'rotate(2deg) translateY(-5px) translateX(0px)', 'rotate(-6deg) translateY(-1px) translateX(-3px)', 'rotate(-3deg)', 'rotate(1deg) translateX(-6px) translateY(6px)',
      ],
      PickItemDetail: 'https://download4.qcplay.com/sakura/cg_min/1.png',
      PickItemDetailTitle: 'https://download4.qcplay.com/sakura/sakura_title/1.png',
      PickItemDetail1: 'https://download4.qcplay.com/sakura/drawing/1.jpg',
      PickItemDetailLoad: 'https://download4.qcplay.com/sakura/drawing_load/1.jpg',
      textArr: [
        '旅途与梦，繁星与诗，一起收集回忆吧！',
        '收集回忆相册，赢锦鲤大奖，',
        '《魔卡少女樱：回忆钥匙》梦幻盲盒「繁星与诗」即将开启，',
      ],
      shareText: '收集回忆相册，赢锦鲤大奖',
      optText: '',
      pageSize: 4,
      totalPages: 5,
      currentRoles1Index: 1,
      operation: 'hope',
      ruleShow: false,
      taskShow: false,
      recordShow: false,
      getShow: false,
      secReward: false,
      loopInt: null,
      showPicItem: {},
      switchPicItem: {},
      isUserInfo: false,
      copyEnd: true,
      queryObj: {},
      observer: null,
      observer1: null,
      observer2: null,
      observer3: null,
      game_id: null,
      role_id: null,
      sign: null,
      token: null,
      cherryStatusFlag: false,
      isPC: null,
      userName: '',
      shareImg: null,
      cgFlag: false,
      changeKey: 'next'
    };
  },
  created() {
    if (
      this.$route.query.game_id &&
      this.$route.query.role_id &&
      this.$route.query.token
    ) {
      this.game_id = this.$route.query.game_id;
      this.role_id = this.$route.query.role_id;
      this.sign = this.$route.query.sign;
      this.token = this.$route.query.token;
      this.secretFreeLogin();
    } else {
      this.initData();
    }
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    if (localStorage.getItem('objUserInfo') === null) {
    } else {
      this.objUserInfo = JSON.parse(localStorage.getItem('objUserInfo'));
      this.setUserInfo(this.objUserInfo);
      this.onInitDataCallback({ ... this.objUserInfo, needAccount: false });
    }

    this.isWechatBrowser = wechatBrowser();
    if (this.isWechatBrowser) { // 在微信app下

    } else {
      // safari下底部被遮住
      if ((/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)) && !/EdgiOS/.test(navigator.userAgent)) {
        this.isSafari = true;
      }
    }

    var userAgent = navigator.userAgent.toLowerCase();
    this.isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;

    if (this.isPC) {
      this.$router.push('pc');
      console.log(this.isPC, '当前设备是 PC');
    } else {
      console.log('当前设备不是 PC');
    }

    // 埋点
    const bl = buriedLogger('sakura', '魔卡少女樱_生日集卡');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/sakura/card/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
    // reload();
    this.preloadingShow = false;

    for (var i = 1; i <= 20; i++) {
      this.cgPicList.push({
        imgSrc: `https://download4.qcplay.com/sakura/cg/${i}.png`,
        imgSrcLock: `https://download4.qcplay.com/sakura/cg/${i}_lock.png`,
      })
    }
    this.isSetShare();
  },
  mounted() {
    this.indexSwiper()
    this.incrementTo100()
    this.initRolesSwiper()
    this.initGameSwiper()
    this.createObserver()
    const that = this
    function adaptation(ele, that) {
      const visibleArea = window.innerWidth * window.innerHeight;
      const outDom = document.getElementById(ele).getBoundingClientRect();
      const style = window.getComputedStyle(that.$refs[ele]);


      // 元素本身的面积
      const totalArea = outDom.width * outDom.height;
      // 面积比例
      const ratio = (visibleArea * 1.3) / totalArea;
      const transform = style.transform === 'none' ? `scale(${ratio})` : `${style.transform} scale(${ratio})`;
      that.$refs[ele].style.transform = transform;
      console.log(that.$refs[ele].style.transform, 'this.$refs.showImg.style.transform')
    }
    adaptation('showImg', that)
    adaptation('showImg1', that)
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ]),
    enTerActiveClass() {
      const str = `animated ${this.changeKey === 'next' ? 'fadeInRight' : 'fadeInLeft'}`
      console.log(str)
      return str
    },
    getBackgroundStyle() {
      if (this.switchToShow) {
        const imageUrl = `https://download4.qcplay.com/sakura/cardPrev/pop/operation_bg.png`
        console.log(imageUrl, '切换到显示');
        return {
          backgroundImage: `url(${imageUrl})`,
        }
      } else {
        return {}
      }
    },
    picSwiperShow() {
      if (this.horizontalShow) {
        return false
      }
      if (this.verticalShow) {
        return false
      }
      if (this.pictureDeatilsShow) {
        return false
      } else if (this.pictureListShow) {
        return false
      } else {
        return true
      }

    },
    cg_sakura() {
      const cg = `https://download4.qcplay.com/sakura/cardPrev/02/${this.currentRoles1Index}.png`
      // const cgDraw = require(`@/assets/images/active/sakura/card/04/cg/${this.currentRoles1Index}.jpg`)
      const cgDraw = `https://download4.qcplay.com/sakura/drawing/2${this.currentRoles1Index}.jpg`
      let show = "horizontalShow"
      if (this.currentRoles1Index == 2) {
        show = "verticalShow"
      }
      if (this.currentRoles1Index == 4) {
        show = "verticalShow"
      }

      this.PickItemDetail1 = cgDraw
      this.$forceUpdate()
      console.log(`@/assets/images/active/sakura/card/04/cg/${this.currentRoles1Index}.jpg`)
      return {
        'cg': cg,
        'show': show
      }
    }
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (oldValue.account) {
          if (newValue.account !== oldValue.account) {
            if (!newValue.account) {
              // TAG: 注销的时候
              this.clearActiveInfo();
              this.initData()
            } else {
              console.log('登录成功')
              this.initData()
            }
          }
        }
      }
    },
    isUserInfo: {
      handler(newValue, oldValue) {
        if (newValue) {
        } else {
        }
      }
    },

  },
  methods: {
    changeDetails(key) {
      if (this.horizontalShow) {
        this.logger.sum(`魔卡少女樱_生日集卡，horizontalShow,${key}`)
      }
      if (this.verticalShow) {
        this.logger.sum(`魔卡少女樱_生日集卡，verticalShow,${key}`)
      }
      let id = this.showPicItem.card_id - 1
      if (key === 'next') {
        if (this.showPicItem.card_id === 20) return this.onToast('已经到头啦')
        id++
        this.showPicItem = this.activity.all_card_list[id]
      }
      if (key === 'prev') {
        if (this.showPicItem.card_id === 1) return this.onToast('已经到头啦')
        id = id - 1
        this.showPicItem = this.activity.all_card_list[id]
      }
      this.PickItemDetail = `https://download4.qcplay.com/sakura/cg_min/${this.showPicItem.card_id}.png`
      this.PickItemDetail1 = `https://download4.qcplay.com/sakura/drawing/${this.showPicItem.card_id}.jpg`
      this.PickItemDetailLoad = `https://download4.qcplay.com/sakura/drawing_load/${this.showPicItem.card_id}.jpg`
      this.PickItemDetailTitle = `https://download4.qcplay.com/sakura/sakura_title/${this.showPicItem.card_id}.png`
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          console.log(canvas, 'canvas')
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
        });
    },
    // 免密登录请求
    secretFreeLogin() {
      let params = {
        game_id: this.game_id,
        role_id: this.role_id,
        sign: this.sign,
        token: this.token
      };
      secretFreeLoginApi(params).then(response => {
        if (response.code == 200) {
          localStorage.setItem('access_token', response.data.access_token);
          this.initData();
          this.logger.sum("免密登录成功");
        } else {
          this.logger.sum("免密登录失败");
          this.onToast(response.message);
        }
      });
    },
    createObserver() {
      const options = {
        root: null, // 使用浏览器视窗作为视口
        threshold: 1 // 在每个交叉比例阈值上触发回调
      };
      const options1 = {
        root: null, // 使用浏览器视窗作为视口
        threshold: 0.5 // 在每个交叉比例阈值上触发回调
      };
      const that = this

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {

          if (entry.isIntersecting) {
            // 交叉区域的面积
            const visibleArea = window.innerWidth * window.innerHeight;
            // 元素本身的面积
            const totalArea = entry.intersectionRect.width * entry.intersectionRect.height;
            // 面积比例
            const ratio = totalArea / visibleArea;
            const style = window.getComputedStyle(this.$refs.fourthChild);
            let translateYStyle

            if (ratio > 0.82) {
              const scaleNum = Math.round((visibleArea * 0.79 / totalArea) * 100) / 100
              if (this.$refs.fourthChild) {
                // 使用getComputedStyle()获取元素的所有最终CSS属性值

                // 从style对象中获取transform属性的值
                const currentTransform = style.transform;
                // 检查当前的transform值是否是"none"
                const newTransform = currentTransform === 'none' ? `scale(${scaleNum})` : `${currentTransform} scale(${scaleNum})`;
                that.$nextTick(() => {
                  const rect = this.$refs.fourthChild.getBoundingClientRect();
                  const bottom = that.getDistanceFromChildToParentBottom(this.$refs.fourthChild, this.$refs.fourth)
                  const currentTransform1 = style.transform;
                  const newTransform1 = currentTransform1 === 'none' ? `scale(1) translateX(-${rect.left / scaleNum}px) translateY(${bottom}px)` : `${currentTransform1} scale(1) translateX(-${rect.left / scaleNum}px) translateY(${(bottom)}px)`;
                  this.$refs.fourthChild.style.transform = newTransform1;
                })
                // 将新的transform值设置到元素上
                this.$refs.fourthChild.style.transform = newTransform;
              }
            }

            if (document.getElementById('fourthChild').getBoundingClientRect().top - document.getElementById('top_01').getBoundingClientRect().bottom < 5) {
              translateYStyle = -(document.getElementById('fourthChild').getBoundingClientRect().top - document.getElementById('top_01').getBoundingClientRect().bottom) + 5
              console.log(translateYStyle, 'translateYStyle')

              const newTransformY = style.transform === 'none' ? `translateY(${translateYStyle}px)` : `${style.transform} translateY(${translateYStyle}px)`;
              this.$refs.fourthChild.style.transform = newTransformY;
            }
          }
        });
      }, options1);
      this.observer1 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 交叉区域的面积
            const visibleArea = window.innerWidth * window.innerHeight;
            // 元素本身的面积
            const totalArea = entry.intersectionRect.width * entry.intersectionRect.height;
            // 面积比例
            const ratio = totalArea / visibleArea;
            const scaleNum = Math.round((visibleArea * 0.52 / totalArea) * 100) / 100
            if (ratio > 0.65) {
              const style = window.getComputedStyle(this.$refs.sakura);
              const currentTransform = style.transform;
              const newTransform = currentTransform === 'none' ? `scale(${scaleNum})` : `${currentTransform} scale(${scaleNum})`;
              this.$refs.sakura.style.transform = newTransform;
            }
          }
        })
      }, options);
      this.observer2 = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const outDom = document.getElementById('thrid').getBoundingClientRect();
            // 交叉区域的面积
            const visibleArea = outDom.width * outDom.height;
            // 元素本身的面积
            const totalArea = entry.intersectionRect.width * entry.intersectionRect.height;
            // 面积比例
            const ratio = totalArea / visibleArea;
            console.log(ratio, 'cardcard')
            const scaleNum = Math.round((visibleArea * 0.58 / totalArea) * 100) / 100
            if (ratio > 0.66) {
              const style = window.getComputedStyle(this.$refs.card);
              const currentTransform = style.transform;
              const newTransform = currentTransform === 'none' ? `scale(${scaleNum})` : `${currentTransform} scale(${scaleNum})`;
              this.$refs.card.style.transform = newTransform;
            }
            console.log(totalArea / visibleArea, 'visibleArea')
          }
        })
      }, options);




      this.observer.observe(this.$refs.fourthChild); // 观察.ref="fourthChild"的元素
      this.observer1.observe(this.$refs.sakuraChild); // 观察.ref="fourthChild"的元素
      this.observer2.observe(this.$refs.card); // 观察.ref="fourthChild"的元素
    },
    getDistanceFromChildToParentBottom(childElement, parentElement) {
      // 获取子元素和父元素的位置信息
      const childRect = childElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      // 计算父元素底部位置
      const parentBottomPosition = parentRect.top + parentRect.height;

      // 计算子元素底部位置
      const childBottomPosition = childRect.top + childRect.height;

      // 计算子元素底部到父元素底部的距离
      const distanceToParentBottom = parentBottomPosition - childBottomPosition;

      return distanceToParentBottom;
    },
    getDistanceToWindowBottom(elem) {
      var rect = elem.getBoundingClientRect();
      var elemBottom = rect.bottom;
      var distanceToWindowBottom = window.innerHeight - elemBottom;
      return distanceToWindowBottom;
    },
    goToSlide(index) {
      console.log(this.$refs.mySwiper)
      this.mySwiper.slideTo(index);
    },
    getDistance(refDiv) {
      // 确保元素已经被渲染
      this.$nextTick(() => {
        const rect = refDiv.getBoundingClientRect();
        const topDistance = rect.top;
        const bottomDistance = window.innerHeight - rect.bottom;

        console.log(`距离视窗顶部的距离: ${topDistance}`);
        console.log(`距离视窗底部的距离: ${bottomDistance}`);
      });
    },
    cherryStatus() {
      const that = this
      const params = {
        access_token: localStorage.getItem('access_token') || '',
        code: this.$route.query.code,
        ...this.$route.query
      }

      function isPositiveInteger(str) {
        return /^\d+$/.test(str) && parseInt(str, 10) > 0;
      }
      const { from_id, from_card_id, card_id } = that.$route.query
      if (!isPositiveInteger(card_id)) return
      if (this.$route.query.from_id == this.userInfo.user_id) {
        return
      }
      if (this.$route.query.type == 3) {
        that.switchToShow = true
        that.operationShow = true
        that.showPicItem = JSON.parse(JSON.stringify(that.activity.all_card_list[card_id - 1]))
        that.showPicItem.src = this.cgPicList[card_id - 1].imgSrc
        that.queryObj.gave_account = that.$route.query.from_user
        return
      }
      cherryStatus(params).then(res => {
        if (res.code == 200) {
          this.queryObj = res.data
          if (!res.data.is_effect) {
            this.operationShow = false
            return this.onToast('链接已失效')
          } else {
            if (this.queryObj.type == 1) {
              that.switchToShow = true
              that.operationShow = true
              that.showPicItem = JSON.parse(JSON.stringify(that.activity.all_card_list[card_id - 1]))
              that.showPicItem.src = this.cgPicList[card_id - 1].imgSrc
            }
            if (this.queryObj.type == 2) {
              that.switchToShow = true
              that.switchShow = true
              that.switchPicItem = JSON.parse(JSON.stringify(that.activity.all_card_list[card_id - 1]))
              that.switchPicItem.src1 = that.cgPicList[card_id - 1].imgSrc
              that.showPicItem = JSON.parse(JSON.stringify(that.activity.all_card_list[from_card_id - 1]))
              that.showPicItem.src = that.cgPicList[from_card_id - 1].imgSrc
            }
          }
          console.log(res, 'cherryStatus');
        } else {
          this.onToast(res.message)
        }
      })
    },
    accept(key) {
      console.log('accept')
      const that = this
      const params = {
        access_token: localStorage.getItem('access_token') || '',
        ...this.queryObj,
        ...this.$route.query
      }
      if (this.queryObj.type == 1) {
        receive(params).then(res => {
          if (res.code == 200) {
            that.logger.sum('魔卡少女樱_生日集卡，接受好友赠送')
            this.closePopup('operationShow')
            this.cherryStatusFlag = true
            this.initData()
            this.onToast(res.message)
          } else {
            this.onToast(res.message)
          }
        }).finally(() => {
          this.closePopup('operationShow')
        })
      }

      if (this.queryObj.type == 2) {
        exchange(params).then(res => {
          if (res.code == 200) {
            if (res.data.card_id == 0) {
              this.initData()
              return this.onToast(res.message)
            }

            this.closePopup('switchShow')
            that.logger.sum('魔卡少女樱_生日集卡，接受好友交换')
            this.getShow = true
            this.operationShow = false
            this.PickItemDetail = `https://download4.qcplay.com/sakura/cg_min/${res.data.card_id}.png`
            this.PickItemDetail1 = `https://download4.qcplay.com/sakura/drawing/${res.data.card_id}.jpg`
            this.PickItemDetailLoad = `https://download4.qcplay.com/sakura/drawing_load/${this.showPicItem.card_id}.jpg`
            this.PickItemDetailTitle = `https://download4.qcplay.com/sakura/sakura_title/${res.data.card_id}.png`
            this.cherryStatusFlag = true
            this.initData()
          } else {
            this.onToast(res.message)
          }
        }).finally(() => {
          this.closePopup('switchShow')
          this.switchPicItem = {}
        })
      }

      if (this.$route.query.type == 3) {
        generateGave(params).then(res => {
          if (res.code == 200) {
            this.closePopup('operationShow')
            if (res.data.card_id == 0) {
              this.initData()
              return this.onToast(res.message)
            }
            that.logger.sum('魔卡少女樱_生日集卡，接受好友祈愿')
            this.getShow = true
            this.PickItemDetail = `https://download4.qcplay.com/sakura/cg_min/${res.data.card_id}.png`
            this.PickItemDetail1 = `https://download4.qcplay.com/sakura/drawing/${res.data.card_id}.jpg`
            this.PickItemDetailLoad = `https://download4.qcplay.com/sakura/drawing_load/${this.showPicItem.card_id}.jpg`
            this.PickItemDetailTitle = `https://download4.qcplay.com/sakura/sakura_title/${res.data.card_id}.png`
            this.initData()
            this.onToast(res.message)
          } else {
            this.onToast(res.message)
          }
        }).finally(() => {
          this.closePopup('operationShow')
        })
      }
    },
    sureSwitch() {
      if (!this.switchPicItem.src) {
        return this.onToast('请选择交换照片')
      }
      console.log('切换图片')
      this.pictureListShow = false
      this.pictureDeatilsShow = true
      this.switchShow = true
    },
    surePic(item) {
      console.log(item, 'item')
      if (item.card_id === this.showPicItem.card_id) return this.onToast('不能选择同一张卡片')
      const pic = JSON.parse(JSON.stringify(item))
      pic.src = pic.src1
      this.switchPicItem = pic
    },
    // 复制链接
    onCopy() {
      const my_id = '#my-code'
      const that = this
      if (!that.userInfo.account) {
        console.log('请先登录')
        that.changeLoginPopup(true)
        return that.onToast('很抱歉，请先登录');
      }

      this.copyEnd = false;
      setTimeout(() => {
        this.copyEnd = true;
      }, 1000);
      this.shareShow = false
      this.switchShow = false
      const clipboard = new Clipboard('#my-code');
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        that.logger.sum('魔卡少女樱_生日集卡，链接复制');
        that.onToast('邀请链接复制成功，快快发送给你的好友吧~');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        that.onToast('复制失败');
      });
    },
    reward(userInfo = {}) {
      function throttle(func, delay) {
        let timeoutId;
        return function () {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, arguments);
              timeoutId = null;
            }, delay);
          }
        };
      }
      console.log(this.isUserInfo, 'isUserInfo')
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.taskShow = false
        throttle(this.changeLoginPopup(true), 1000)
        return this.onToast('很抱歉，请先登录');
      }
      console.log(userInfo, '领取奖励')
      this.secReward = true
      if (!userInfo.hasOwnProperty('role_id')) {
        this.taskShow = false
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!userInfo.role_id) {
        this.taskShow = false
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      } else if (!userInfo.role_id > 0) {
        this.taskShow = false
        console.log('选择角色')
        throttle(this.changeOsPopup(true), 1000)
        return
      }
      const params = { access_token: localStorage.getItem('access_token') || '', ...userInfo }
      const that = this
      reward(params).then(response => {
        if (response.code == 200) {
          that.logger.sum('魔卡少女樱_生日集卡，领取奖励');
          console.log(response, '领取奖励')
          that.onToast('领取成功')
          if (that.secReward) {
            that.initData()
            that.secReward = false
          }
          that.taskShow = false
        } else {
          that.onToast(response.message)
        }
      });
    },
    doneTask(item) {
      const that = this
      if (item.id == 1) {
        return
      }
      if (item.id == 2) {
        that.logger.sum('魔卡少女樱_生日集卡，任务2')
        return this.onToast('请前往交换卡片')
      }
      if (item.id == 3) {
        this.logger.sum('魔卡少女樱_生日集卡，点击前往小程序wiki');
        localStorage.setItem("open_link", item.open_link);
        document.onvisibilitychange = function () {
          if (document.visibilityState == 'visible') {
            that.logger.sum('魔卡少女樱_生日集卡，小程序返回活动页');
            console.log('切回应用');
            that.initData()
            that.loopInt = setInterval(function () {
              console.log('检测是否返回应用');
              that.initData()
            }, 1000)
            setTimeout(function () {
              console.log('清除定时器');
              clearInterval(that.loopInt)
            }, 15000)
          }
        };
        // console.log(item.link, ' item.open_link')
        window.location.href = item.link
      }
    },
    generateTask(item) {
      const randomIndex = Math.floor(Math.random() * this.textArr.length);
      const that = this
      // 使用随机索引从数组中选择一个元素
      this.shareText = this.textArr[randomIndex];
      const { protocol, host } = window.location
      if (this.operation == 'give') {
        const params = {
          access_token: localStorage.getItem('access_token') || '',
          card_id: this.showPicItem.card_id,
          type: 1,
        }
        this.optText = `好友向你赠送【${this.showPicItem.name}】,点击查看`
        generateCode(params).then(res => {
          if (res.code == 200) {
            that.logger.sum('魔卡少女樱_生日集卡，发起赠送')
            const code = res.data.data
            this.shareLink = `${protocol}//${host}/sakura/card/enter${getRandomString()}?from_id=${this.userInfo.user_id}&type=1&card_id=${this.showPicItem.card_id}&code=${code}`
            setTimeout(() => {
              this.qrcode(this.shareLink);
              this.$nextTick(() => {
                this.generateShareImage();
              });
            }, 500)
            this.shareShow = true
          } else {
            this.onToast(res.message)
          }
        })
      }

      if (this.operation == 'hope') {
        that.logger.sum('魔卡少女樱_生日集卡，发起祈愿')
        const params = {
          access_token: localStorage.getItem('access_token') || '',
          card_id: this.showPicItem.card_id,
          type: 3,
          from_id: this.userInfo.user_id,
        }
        this.optText = `好友向你祈愿【${this.showPicItem.name}】,点击查看`
        console.log(this.user_info)
        const user_name = this.userInfo.role_name ? this.userInfo.role_name : this.userInfo.account.substring(this.userInfo.account.length - 4, this.userInfo.account)
        this.shareLink = `${protocol}//${host}/sakura/card/enter${getRandomString()}?from_id=${this.userInfo.user_id}&type=3&card_id=${this.showPicItem.card_id}&from_user=${user_name}`

        this.shareShow = true
        setTimeout(() => {
          this.qrcode(this.shareLink);
          this.$nextTick(() => {
            this.generateShareImage();
          });
        }, 50)
      }

      if (this.operation == 'switch') {
        that.logger.sum('魔卡少女樱_生日集卡，发起交换')
        const params = {
          access_token: localStorage.getItem('access_token') || '',
          card_id: this.showPicItem.card_id,
          type: 2,
        }
        if (!this.switchPicItem.card_id) return this.onToast('请选择交换的卡片')
        this.optText = `好友正在使用【${this.showPicItem.name}】你交换【${this.switchPicItem.name}】,点击查看`
        generateCode(params).then(res => {
          if (res.code == 200) {
            const code = res.data.data
            this.shareLink = `${protocol}//${host}/sakura/card/enter${getRandomString()}?from_id=${this.userInfo.user_id}&type=2&card_id=${this.switchPicItem.card_id}&from_card_id=${this.showPicItem.card_id}&code=${code}`
            setTimeout(() => {
              this.qrcode(this.shareLink);
              this.$nextTick(() => {
                this.generateShareImage();
              });
            }, 500)
            this.shareShow = true
          } else {
            this.onToast(res.message)
          }
        })
      }

    },
    setOperation(key) {
      if (key !== 'hope') {
        if (!this.showPicItem.hasOwnProperty('num')) {
          return this.onToast('请先集齐卡片')
        } else {
          if (this.showPicItem.num <= 1) {
            return this.onToast('您未拥有多余照片，快用其他照片和好友交换吧')
          }
        }
      }
      this.operation = key;

      if (key == 'give') {
        this.generateTask()
      }

      if (key == 'hope') {
        this.generateTask()
      }

      if (key == 'switch') {
        this.switchShow = true
      }

    },
    switchImg() {
      if (this.switchToShow) {
        return
      }
      this.pictureListShow = true
      this.pictureDeatilsShow = false
      this.switchShow = false
    },
    picItemClick(item) {
      const that = this
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this.showPicItem = item
      this.pictureDeatilsShow = true


      document.addEventListener('DOMContentLoaded', (event) => {
        // 获取需要观察的DOM元素
        const target = document.getElementById('decoration1');
        if (target) {
          // 开始观察元素
          this.observeElement()
        }
      });

      that.$nextTick(() => {
        const decoration = document.getElementById('decoration1')
        const distanceToWindowBottom = that.getDistanceToWindowBottom(decoration);
        var elemBottom = decoration.getBoundingClientRect().bottom
        // 如果距离不为零，则调整元素的marginBottom来使其距离为零
        if (elemBottom !== window.innerHeight) {
          decoration.style.bottom = `-${distanceToWindowBottom}px`;
        }
      })
      this.PickItemDetail = `https://download4.qcplay.com/sakura/cg_min/${item.card_id}.png`
      this.PickItemDetail1 = `https://download4.qcplay.com/sakura/drawing/${item.card_id}.jpg`
      this.PickItemDetailLoad = `https://download4.qcplay.com/sakura/drawing_load/${this.showPicItem.card_id}.jpg`
      this.PickItemDetailTitle = `https://download4.qcplay.com/sakura/sakura_title/${item.card_id}.png`
    },
    btn_Click(key) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }

      this.btn_list.forEach(item => {
        if (item.key == key) {
          item.className = 'btn_active'
          this.mainBackground = item.background
          this.recordIndex = 1
        } else {
          item.className = 'btn'
        }
      })
      this.changeRecordIndex()
    },
    changeRecordIndex(key) {
      if (!this.isUserInfo) {
        console.log('请先登录')
        this.changeLoginPopup(true)
        return this.onToast('很抱歉，请先登录');
      }
      this.changeKey = key

      let imgArr = []
      if (this.btn_list[0].className === 'btn_active') {
        imgArr = this.activity.all_card_list
      }
      if (this.btn_list[1].className === 'btn_active') {
        imgArr = this.activity.my_card_list
      }
      if (this.btn_list[2].className === 'btn_active') {
        imgArr = this.activity.not_has_card_list
      }
      let totalPages = Math.ceil(imgArr.length / this.pageSize);
      this.totalPages = totalPages
      if (key == 'next') {
        if (this.recordIndex < this.totalPages) {
          this.recordIndex++;
        } else {
          return this.onToast('已经到头啦')
        }
      } else if (key == 'prev') {
        if (this.recordIndex > 1) {
          this.recordIndex--
        } else {
          return this.onToast('已经到头啦')
        }
      }
      this.showPoicList = []
      let start = (this.recordIndex - 1) * this.pageSize;
      let end = start + this.pageSize;
      this.showPoicList = imgArr.slice(start, end);
      this.$set(this, 'showPoicList', this.showPoicList)
    },
    // 初始化接口
    initData() {
      const params = { access_token: localStorage.getItem('access_token') || '' }
      const that = this
      onGetInitDataAPI(params).then(response => {
        if (response.code === 200) {
          that.isUserInfo = true
          const { protocol, host } = window.location
          const my_card_list_id = response.data.activity.my_card_list.map(item => item.card_id)
          response.data.activity.all_card_list.forEach(item => {
            item.src1 = this.cgPicList[item.card_id - 1].imgSrc
            if (my_card_list_id.includes(item.card_id)) {
              item.src = this.cgPicList[item.card_id - 1].imgSrc
              const it = response.data.activity.my_card_list.find(obj => obj.card_id === item.card_id)
              item.num = it.num
            } else {
              item.src = this.cgPicList[item.card_id - 1].imgSrcLock
              item.num = 0
            }
          })
          response.data.activity.my_card_list.forEach(item => {
            item.src = this.cgPicList[item.card_id - 1].imgSrc
          })
          response.data.activity.not_has_card_list.forEach(item => {
            item.src = this.cgPicList[item.card_id - 1].imgSrcLock
            item.src1 = this.cgPicList[item.card_id - 1].imgSrc
          })
          this.activity = response.data.activity
          this.changeRecordIndex()
          if (this.activity.task_info[2]._get == true) {
            console.log('清除定时器');
            clearInterval(that.loopInt)
          }

          const obj = {
            role_id: response.data.activity.role_id,
            role_name: response.data.activity.role_name,
            server_id: response.data.activity.server_id,
            server_name: response.data.activity.server_name,
            user_id: response.data.activity.user_id,
            account: response.data.user_info.account,
          }
          that.onInitState(obj)
          // 被交换方
          if (that.$route.fullPath.indexOf('type') > -1 && that.cherryStatusFlag === false) {
            console.log('被交换方')
            that.cherryStatus()
          }
        }
      });
    },
    incrementTo100() {
      const target = 100;
      const duration = 700; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器
          if (that.userInfo.user_id) {
            if (that.$route.query.from_id === that.userInfo.user_id) {
              return setTimeout(() => {
                that.goToSlide(1)
                that.logger.sum('魔卡少女樱_生日集卡，进入自己链接')
              }, 100)
            }
          }

        }
      }, stepTime);

    },
    indexSwiper() {
      const that = this
      function getDistanceToWindowBottom(elem) {
        var rect = elem.getBoundingClientRect();
        var elemBottom = rect.bottom;
        var distanceToWindowBottom = window.innerHeight - elemBottom;
        return distanceToWindowBottom;
      }
      this.mySwiper = new Swiper('.content-swiper-container.swiper-container', {
        effect: 'slide',
        direction: 'vertical',
        slidesPerView: 'auto',
        paginationClickable: false,
        spaceBetween: 0,
        mousewheelControl: true,
        resistanceRatio: 0,
        noSwipingClass: 'play-way-swiper-container',
        initialSlide: 0,
        allowSwipeToNext: true,
        onSlideChangeEnd: function (swiper) {
          if (swiper.activeIndex === 1) {
            that.$nextTick(() => {
              const decoration = document.getElementById('decoration')
              const distanceToWindowBottom = getDistanceToWindowBottom(decoration);
              var elemBottom = decoration.getBoundingClientRect().bottom
              console.log(elemBottom, 'elemBottom')
              console.log(window.innerHeight, 'window.innerHeight')
              const num = Math.abs(window.innerHeight - elemBottom)
              if (num > 10) {
                decoration.style.bottom = `-${distanceToWindowBottom}px`;
              }
            })
          }
          if (swiper.activeIndex === 2) {
            const cgDraw = `https://download4.qcplay.com/sakura/drawing/2${that.currentRoles1Index}.jpg`
            that.PickItemDetail1 = cgDraw
          }
          that.currentSwiperIndex = swiper.activeIndex
          console.log(swiper.activeIndex, 'currentSwiperIndex')
        }
      });
    },
    initGameSwiper() {
      new Swiper('.game-swiper-container.swiper-container', {
        direction: 'horizontal',
        slidesPerView: "auto",
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        pagination: '.game-pagination.swiper-pagination',
        nextButton: '.game-button-next.swiper-button-next',
        prevButton: '.game-button-prev.swiper-button-prev',
        // observer: true,
        // observeParents: true,
        effect: 'coverflow',
        coverflow: {
          rotate: 5,
          stretch: 27,
          depth: 30,
          modifier: 6,
          slideShadows: false
        },
        pagination: '.swiper-pagination',
        // paginationBulletRender: function (swiper, index, className) {
        //   return '<div class="swiper-pagination-bullet >' + '</div>';
        // }
      })
    },
    initRolesSwiper() {
      const that = this
      new Swiper('.roles-swiper-container.swiper-container', {
        slidesPerView: 5,
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        centeredSlides: true,
        // observer: true,
        // observeParents: true,
        slideToClickedSlide: true,
        onlyExternal: true,
        // nextButton: '.roles-button-next.swiper-button-next',
        // prevButton: '.roles-button-prev.swiper-button-prev',
        onSlideChangeEnd: function (swiper) {
          console.log('roles-swiper-container', swiper.realIndex)
          that.currentRoles1Index = swiper.realIndex + 1
        }
      })
    },
    loginSuccess() {
      console.log('登录成功')
      this.initData()
    },
    onInitState(response) {
      console.log('初始化数据成功');
      this.setUserInfo(response);
      this.onInitDataCallback({ ...response, needAccount: false });
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.secReward = false
      this.isUserInfo = false
      this.queryObj = {}
      localStorage.removeItem('objUserInfo');
      this.activity = {
        "user_id": 0,
        "is_running": true,
        "my_card_list": [
        ],
        "task_info": [
          {
            "id": 1,
            "title": "\u6bcf\u65e5\u8fdb\u5165\u6d3b\u52a8\u9875\u9762",
            "is_random": 0,
            "type": 1,
            "link": "",
            "_get": false,
            "is_get": false,
            "number": 3,
            "desc": "\u6bcf\u65e5\u767b\u5165"
          },
          {
            "id": 2,
            "title": "\u6bcf\u65e5\u8d60\u9001\/\u4ea4\u6362\u7167\u7247",
            "is_random": 1,
            "type": 1,
            "link": "",
            "_get": false,
            "is_get": false,
            "number": 1,
            "desc": "\u4ea4\u6362\u4efb\u52a1"
          },
          {
            "id": 3,
            "title": "\u6dfb\u52a0\u4f01\u5fae",
            "is_random": 0,
            "type": 2,
            "link": "weixin:\/\/dl\/business\/?t=ucuRIk6umDn",
            "_get": false,
            "is_get": false,
            "number": 3,
            "desc": "\u4f01\u5fae\u4efb\u52a1"
          }
        ],
        "all_card_list": [
          {
            "card_id": 1,
            "name": "\u900f\u660e\u4e4b\u7ffc"
          },
          {
            "card_id": 2,
            "name": "\u5e93\u6d1b\u9b54\u6cd5\u4f7f"
          },
          {
            "card_id": 3,
            "name": "\u7ea2\u5fc3\u7efd\u653e"
          },
          {
            "card_id": 4,
            "name": "\u661f\u4e4b\u6a31"
          },
          {
            "card_id": 5,
            "name": "\u8776\u4e4b\u68a6"
          },
          {
            "card_id": 6,
            "name": "\u793c\u7269\u5723\u591c"
          },
          {
            "card_id": 7,
            "name": "\u548c\u98ce\u5c0f\u6a31"
          },
          {
            "card_id": 8,
            "name": "\u7ae5\u8bdd\u7ea2\u8336\u4f1a"
          },
          {
            "card_id": 9,
            "name": "\u66fe\u7956\u7236\u7684\u793c\u7269"
          },
          {
            "card_id": 10,
            "name": "\u65b0\u6625\u548c\u670d"
          },
          {
            "card_id": 11,
            "name": "\u751c\u67ff\u8f6f\u66f2\u5947"
          },
          {
            "card_id": 12,
            "name": "\u91d1\u8272\u5947\u8ff9"
          },
          {
            "card_id": 13,
            "name": "\u53ef\u7231\u732b\u54aa"
          },
          {
            "card_id": 14,
            "name": "\u751f\u6d3b\u65e5\u8bb0"
          },
          {
            "card_id": 15,
            "name": "\u955c\u82b1\u957f\u88d9"
          },
          {
            "card_id": 16,
            "name": "\u591c\u660e\u4e4b\u661f"
          },
          {
            "card_id": 17,
            "name": "\u73af\u6e38\u65c5\u884c\u8005"
          },
          {
            "card_id": 18,
            "name": "\u9526\u5c3e\u7409\u91d1"
          },
          {
            "card_id": 19,
            "name": "\u7ef5\u7f8a\u5c0f\u6a31"
          },
          {
            "card_id": 20,
            "name": "\u7fa4\u661f\u793c\u8d5e"
          }
        ],
        "not_has_card_list": [
          {
            "num": 0,
            "card_id": 2,
            "name": "\u5e93\u6d1b\u9b54\u6cd5\u4f7f"
          },
          {
            "num": 0,
            "card_id": 3,
            "name": "\u7ea2\u5fc3\u7efd\u653e"
          },
          {
            "num": 0,
            "card_id": 4,
            "name": "\u661f\u4e4b\u6a31"
          },
          {
            "num": 0,
            "card_id": 5,
            "name": "\u8776\u4e4b\u68a6"
          },
          {
            "num": 0,
            "card_id": 6,
            "name": "\u793c\u7269\u5723\u591c"
          },
          {
            "num": 0,
            "card_id": 7,
            "name": "\u548c\u98ce\u5c0f\u6a31"
          },
          {
            "num": 0,
            "card_id": 8,
            "name": "\u7ae5\u8bdd\u7ea2\u8336\u4f1a"
          },
          {
            "num": 0,
            "card_id": 9,
            "name": "\u66fe\u7956\u7236\u7684\u793c\u7269"
          },
          {
            "num": 0,
            "card_id": 10,
            "name": "\u65b0\u6625\u548c\u670d"
          },
          {
            "num": 0,
            "card_id": 12,
            "name": "\u91d1\u8272\u5947\u8ff9"
          },
          {
            "num": 0,
            "card_id": 14,
            "name": "\u751f\u6d3b\u65e5\u8bb0"
          },
          {
            "num": 0,
            "card_id": 15,
            "name": "\u955c\u82b1\u957f\u88d9"
          },
          {
            "num": 0,
            "card_id": 16,
            "name": "\u591c\u660e\u4e4b\u661f"
          },
          {
            "num": 0,
            "card_id": 17,
            "name": "\u73af\u6e38\u65c5\u884c\u8005"
          },
          {
            "num": 0,
            "card_id": 18,
            "name": "\u9526\u5c3e\u7409\u91d1"
          },
          {
            "num": 0,
            "card_id": 19,
            "name": "\u7ef5\u7f8a\u5c0f\u6a31"
          },
          {
            "num": 0,
            "card_id": 20,
            "name": "\u7fa4\u661f\u793c\u8d5e"
          }
        ],
        "record_list": [
        ],
        "reward_list": {
          "data": [
            {
              "number": 3,
              "package_id": 11,
              "_get": false,
              "is_get": false
            },
            {
              "number": 5,
              "package_id": 22,
              "_get": false,
              "is_get": false
            },
            {
              "number": 15,
              "package_id": 33,
              "_get": false,
              "is_get": false
            },
            {
              "number": 20,
              "package_id": 44,
              "_get": false,
              "is_get": false
            }
          ],
          "number": 1
        },
        "is_bind": 0,
        "role_id": "",
        "role_name": "",
        "server_id": 0,
        "server_name": "",
        "platform": ""
      },
        this.goToSlide(0)
      this.showPoicList = [
        { "card_id": 1, "name": "透明之翼", "src": "https://download4.qcplay.com/sakura/cg/1_lock.png" }, { "card_id": 2, "name": "库洛魔法使", "src": "https://download4.qcplay.com/sakura/cg/2_lock.png" }, { "card_id": 3, "name": "红心绽放", "src": "https://download4.qcplay.com/sakura/cg/3_lock.png" }, { "card_id": 4, "name": "星之樱", "src": "https://download4.qcplay.com/sakura/cg/4_lock.png" }
      ]
      this.btn_list = [
        { key: 1, className: 'btn_active', background: 'all_main' },
        { key: 2, className: 'btn', background: 'collected_main' },
        { key: 3, className: 'btn', background: 'notCollected_main' },
      ]
      this.mainBackground = 'all_main'
      this.recordIndex = 1
      this.totalPages = 5
      this.pictureDeatilsShow = false
      this.pictureListShow = false
    },
    // 选择角色后
    selectCallback(response) {
    },
    getSelectInfo(response) {
      this.isUserInfo = true
      console.log('选中角色')
      if (this.secReward) {
        this.reward(response)
      }
    },
    // 区组弹窗注销-相关参数复位
    osCancell() {
      this.clearActiveInfo()
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    openPopup(name) {
      this.logger.sum(`魔卡少女樱_生日集卡，${name}`)
      if (name == 'taskShow') {
        if (!this.userInfo.account) {
          console.log('请先登录')
          this.changeLoginPopup(true)
          return this.onToast('很抱歉，请先登录');
        }
      }
      if (name == 'recordShow') {
        this.userName = this.userInfo.role_name ? this.userInfo.role_name : this.userInfo.account.substring(this.userInfo.account.length - 4, this.userInfo.account)
      }
      this[name] = true;
    },
    openCg(name) {
      this.logger.sum(`魔卡少女樱_生日集卡，${name}`)
      this.cgFlag = true
      this[name] = true;
    },
    closePopup(name) {
      this.switchToShow = false
      this.switchPicItem = {}
      this.cgFlag = false
      if (name === 'shareShow' && !this.copyEnd) {
        return console.log('等待复制')
      }
      console.log('关闭弹窗')
      this[name] = false;
    },
    // 微信分享
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/sakura/card/enter${getRandomString()}`,
        title: '旅途与梦·繁星与诗丨小樱生日特别活动',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/4qDuutlQId8189cT0MhtBCP4aXtISAdwk0qySD96.jpeg',
        desc: '梦幻盲盒开启，收集小樱生日回忆相册，赢取周边好礼'
      })
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/card/index/index.vue